import { render } from "./Home.vue?vue&type=template&id=cfa79b90&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=cfa79b90&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cfa79b90"

export default script